import React from "react";
import { Link } from "react-router-dom";

const Button = (props) => {
	const { classNames, ...rest } = props;

	const widthClass = props.fullWidth || props.fullwidth ? " w-full" : "";
	const solidClasses =
		" transition ease-in-out duration-300 rounded-lg bg-blue-600 mt-5 hover:scale-105 px-6 py-3 text-md font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600";
	const ghostClasses =
		" transition ease-in-out duration-300 rounded-lg bg-transparent mt-5 hover:scale-105 px-6 py-3 text-md font-semibold text-blue-600 border border-blue-600 hover:bg-blue-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600";
	const baseClasses =
		(classNames || "") + widthClass + (props.ghost ? ghostClasses : solidClasses);

	if (props.href && !props.onClick) {
		return (
			<a className={baseClasses} href={props.href} target={props.target}>
				{props.children}
			</a>
		);
	} else if (props.href && props.onClick) {
		return (
			<a
				className={baseClasses}
				href={props.href}
				target={props.target}
				onClick={props.onClick}
			>
				{props.children}
			</a>
		);
	} else if (props.to) {
		return (
			<Link to={props.to} className={baseClasses}>
				{props.children}
			</Link>
		);
	} else {
		return (
			<button
				className={`${baseClasses} ${
					props.disabled
						? props.ghost
							? "opacity-70 border-gray-300 text-gray-400 cursor-not-allowed"
							: "opacity-70 bg-gray-400 cursor-not-allowed"
						: ""
				}`}
				documentType={props.documentType}
				onClick={
					props.disabled
						? (e) => {
								e.preventDefault();
								alert("Je hebt nog niet alle velden ingevuld");
						  }
						: props.onClick
				}
				disabled={props.disabled}
				{...rest}
			>
				{props.children}
			</button>
		);
	}
};

export default Button;
